import { createClient } from "@connectrpc/connect";
import { ClientesPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_clientes_pb";
import { ClienteResponse } from "../../../shared/response/terceros/ClienteResponse";
import { ClientePayload } from "../../../shared/services/api/payload/terceros/ClientePayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcTransportProvider } from "../../../shared/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../shared/services/grpc/mapConnectError";
import { ClienteService, toClienteResponse } from "./ClienteService";

/** Alta y edición de cliente; el guardado reemplaza la fila en la tabla (`upsert` de la base). */
export class ClienteSaveService extends ServiceSaveBase<ClienteResponse, ClientePayload> {
  protected readonly cache = ClienteService.instance;

  /** gRPC-Web (`ClientesPlataformaService.GuardarCliente`): sin `id` crea, con `id` edita. */
  protected async sendSave(request: ClientePayload): Promise<ClienteResponse> {
    const client = createClient(ClientesPlataformaService, grpcTransportProvider.get());
    try {
      const item = await client.guardarCliente({
        id: request.id ?? undefined,
        nit: request.nit,
        razonSocial: request.razonSocial,
        email: request.email,
        telefono: request.telefono,
        promotorId: request.promotorId ?? undefined,
      });
      return toClienteResponse(item);
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}
